import {isEmpty} from "./CommonMethod";

export function validator(constraint, data, style){
    const isRequiredError = constraint?.required && isEmpty(data);
    const updatedStyle = {
        width: '100%',
        ...style,
        ...(isRequiredError
            && {
                outline: 'none',

                backgroundColor: '#ffe5e5',
                border: '1px solid #e53939',
            }),
    };
    return {
        updatedStyle,
        isRequiredError,
    };
}

export function validateStyle(constraint, data, style){
    const isRequiredError = constraint?.required && (!data || data.trim() === '');
    return {
        width: '100%',
        ...(isRequiredError
            ? {
                outline: 'none',

                backgroundColor: '#ffe5e5',
                border: '1px solid #e53939',
            }
            : style),
    }
}

export function getRequiredError(required, data){
    return required && (!data || data.trim() === '');
}


export function valid(required, target, value, onChange) {
    const isRequiredError = required && isEmpty(value);
    onChange(prev => ({
        ...prev,
        required_validate: { ...prev?.required_validate, [target]: isRequiredError ? false : true }
    }));
}
